<template>
  <footer class="footer">
    <div class="content has-text-centered">
      <p>
        This website was built with out code using
        <strong>
          <a href="https://getbiew.com/">Biew</a>
        </strong>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "TheFooter"
};
</script>
